'use client';

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './TextLeftPictureRight.module.scss';

interface TextLeftPictureRightProps {
    title?: React.ReactNode;
    id?: string;
    subtitle?: string;
    description?: string;
    imageUrl?: string;
    imageTitle?: string;
}


const TextLeftPictureRight: React.FC<TextLeftPictureRightProps> = ({
    title,
    id,
    subtitle,
    description,
    imageUrl,
    imageTitle = '',
}) => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: false, easing: 'ease-in-out' });
        AOS.refresh();

        const handleScroll = () => AOS.refresh();
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <section className={styles.wrapper} id={id}>
            <div className={styles.inner}>
                <div className={styles.textBlock}>
                    {subtitle && <h3 className={styles.subtitle} data-aos="fade-up">{subtitle}</h3>}
                    <h2 className={styles.title} data-aos="fade-up" data-aos-delay="100">{title}</h2>
                    <p className={styles.description} data-aos="fade-up" data-aos-delay="200">{description}</p>
                </div>
                <figure className={styles.imageWrapper} data-aos="fade-up" data-aos-delay="200">
                    <div className={styles.imageInner}>
                        <img
                            src={imageUrl}
                            alt={imageTitle || (typeof title === 'string' ? title : 'Artwork')}
                            className={styles.image}
                            loading="lazy"
                            decoding="async"
                        />
                        <figcaption className={styles.hoverLabel}>{imageTitle || 'Artwork'}</figcaption>
                    </div>
                </figure>
            </div>
        </section>
    );
};

export default TextLeftPictureRight;
